import { Injectable } from '@angular/core';
import { Command, Random, StateService } from 'flux-core';
import { DataStore } from 'flux-store';
import { CreateDiagram } from './create-diagram.cmd';
import { TranslateService } from '@ngx-translate/core';

/**
 * CreateDiagramLink to create diagram shared by link.
 */
@Injectable()
@Command()
export class CreateDiagramLink extends CreateDiagram {
    // Team diagram create command.
    constructor(
        protected random: Random,
        protected state: StateService<any, any>,
        protected dataStore: DataStore,
        protected translate: TranslateService,
    ) {
        super( random, state, dataStore, translate );
    }

    /**
     * This function will call the Create Diagram super class,
     * which adds the newly created diagram into Recent Diagrams
     * List.
     */
    public executeResult( response: any ): boolean {
        return super.executeResult( response );
    }
}

Object.defineProperty( CreateDiagramLink, 'name', {
    value: 'CreateDiagramLink',
});
